import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'error-layout',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
